import React from "react";
import { withTranslation } from "react-i18next";
import Title from "./Title";
import Description from "./Description";

const SuccessScreen = (props) => {
  console.log("SuccessScreen :: Component => Enter");
  const { t } = props;

  return (
    <section>
      <div className="loginIntroTextContainer">
        <Title title={props.headerMsg} />
        <Description description={props.descriptionMsg} />
      </div>
      {/* <button type="button" className="btn min_outlin_btn active" onClick={()=>this.goToNextStep(false)}> */}
      <button
        type="button"
        className="btn min_outlin_btn active"
        onClick={(e) =>
        (window.location.href =
          props.returnUrl && props.returnUrl !== ""
            ? props.returnUrl
            : "/wps/portal/web/forgot")
        }
      >
        {t(props.btnLabel)}{" "}
        <i className="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </section>
  );
};

export default withTranslation()(SuccessScreen);
